angular.module('bmsApp.sm.job')
	.controller('SMAddVisitModalCtrl',
		function ($state,
				  $modalInstance,
				  $scope,
				  $q,
				  notify,
				  SMJobSvc,
				  ConfigService) {


			function init() {
				$scope.config = ConfigService.config;
				$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
					options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
						parentEl: '.modal-content'
					})
				});

				$scope.timePickerConfig = angular.extend(angular.copy($scope.config.uiTimepickerOptions), {
					appendTo: '.modal-content'
				});

				SMJobSvc.options().then(function (response) {
					self.options.jobs = response.data.options;
				});

				self.visits = [
					{
						employees: [{}]
					}
				]

			}

			// ------------------------------- VisitList Directives Callbacks ----------------------------
			function minutesUpdated(visit) {
				if (visit) {
					var hours = visit.hours || 0;
					var mins = visit.minutes || 0;
					visit.duration_in_mins = (parseFloat(hours) * 60) + parseFloat(mins);
				}
			}

			function removeVisitAtIndex(index) {
				self.job.visits.splice(index, 1);
			}

			function submit() {
				console.log(self.formValidator.valid());
				if (self.formValidator.valid()) {
					let availabilityChecks = [];
					angular.forEach(self.visits, function (visit) {
						// combine the date/time columns
						angular.extend(visit, {
							visit_date: moment(visit.visit_date).format('YYYY-MM-DD') + ' ' + visit.visit_time.format('HH:mm')
						});
						// self.job.visits.push(visit);

						let job = {
							id: self.job.id,
						};
						let requiredCheckCount = Math.max(visit.employees.length, 1);
						for(let i = 0; i < requiredCheckCount; i++) {
							let employeeData;
							let employee = visit.employees[i];
							if (employee) {
								employeeData = {
									id: employee.id,
								};
							} else {
								employeeData = null;
							}
							availabilityChecks.push(
								SMJobSvc.checkVisitAvailability(visit, employeeData, job)
							);
						}
					});

					let visitsAvailable = true;
					$q.all(availabilityChecks)
						.then(function (responses) {
							angular.forEach(responses, function (response) {
								if (response.data.is_available !== true) {
									visitsAvailable = false;
									notify({
										message: 'Cannot save visit: employee is already booked, please check availability schedule',
										classes: 'error',
										duration: '0'
									});
								}
							});
							if (!visitsAvailable) {
								self.processing = false;
								return;
							}
							// Pushing the visit like this is AWFUL, but it is what it is
							self.job.visits.push(self.visits[0]);
							SMJobSvc.save(self.job)
								.then(function (response) {
									$modalInstance.close(response);
								});
						});

				}
			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			var self = $scope.SMAddVisitCtrl = {
				formvalidatorconfig: {},
				formValidator: {},
				loading: true,
				options: {},
				methods: {
					init: init,
					cancel: cancel,
					submit: submit,
					minutesUpdated: minutesUpdated,
					removeVisitAtIndex: removeVisitAtIndex
				}
			}

		});
